import { useContext } from 'react';
import { Route } from 'react-router-dom';
import userPersonas from '@common/constants/userPersonas';
import AuthCheckWrapper from '@common/components/AuthCheckWrapper';
import { BrandContext } from '@zg-rentals/multibrand-ui/lib/BrandContext';
import UserActions from '@common/actions/UserActions';
import AppConstants from '@common/constants/AppConstants';
import { AuthContext } from '@zg-rentals/particles-js-auth-hooks';
import { useAsync } from 'react-use';
import { pathsManifest } from '@zg-rentals/particles-js-auth';

type Props = {
  render: (props: Record<string, any>) => any;
  path: string;
  dispatch: (...args: any[]) => any;
  exact?: boolean;
};

export const RouteWithAuth = ({ render, ...props }: Props): JSX.Element => {
  const { dispatch, ...propsWithoutDispatch } = props;
  // @ts-expect-error  will be addressed in RJS upgrade will be addressed in RJS upgrade
  const { brand } = useContext(BrandContext);
  const auth = useContext(AuthContext);

  const persona = props.path.includes('/renter-hub/') ? userPersonas.RENTER : userPersonas.LANDLORD;

  const appName = persona === userPersonas.LANDLORD ? AppConstants.RENTAL_MANAGER : AppConstants.RENTER_HUB;

  const { loading, error } = useAsync(async () => {
    if (auth.user.hasStrongAuthentication) return;

    const getUserRequest = await UserActions.getUser({
      appName,
      pageWithSensitiveInformation: true,
      includeSummary: true,
      brand,
    });

    const result = await dispatch(getUserRequest);

    if (!result.hasStrongAuthentication) {
      auth.signout();
      throw new Error('user does not have strong authentication');
    } else {
      auth.signin(result);
      auth.refreshSessionExpirationDate(result.sessionSecondsRemaining * 1000);
    }
  }, [appName, brand]);

  if (error) {
    const toUrl = props.path;
    const redirectUrl = pathsManifest.zillow.signInPage(toUrl, '');
    window.location.href = redirectUrl;
    return <></>;
  }

  if (loading) {
    return <></>;
  }

  return (
    <Route
      {...propsWithoutDispatch}
      render={(routeProps) => {
        /*
                    FIXME: doesn't work with "*" wildcards, passing a userpersona is bad design
                    and there are better ways of detecting this automatically or splitting the imports
                    for rh/rm (no common)
                */
        return (
          <AuthCheckWrapper requireStrongAuthentication appType={persona}>
            {render({ ...routeProps, loading: true })}
          </AuthCheckWrapper>
        );
      }}
    />
  );
};
